'use client';

import { useTranslations } from 'next-intl';
import React from 'react';

import { Drawer } from '@ui/components/common/drawer';
import { Activity } from '@website/services/activities.service';

import { ActivityDrawerContent } from './ActivityDrawerContent';

interface ActivityDrawerProps {
  activity: Activity | null;
  isOpen: boolean;
  onClose: () => void;
  onPrev?: () => void;
  onNext?: () => void;
  currentIndex?: number;
  totalCount?: number;
}

export function ActivityDrawer({
  activity,
  isOpen,
  onClose,
  onPrev,
  onNext,
  currentIndex,
  totalCount
}: ActivityDrawerProps) {
  const t = useTranslations('ActivityDrawer');

  if (!isOpen || !activity) {
    return null;
  }

  return (
    <Drawer
      open={isOpen}
      onOpenChange={(openStatus: boolean) => {
        if (!openStatus) {
          onClose();
        }
      }}
      side="bottom"
      trigger={<span className="sr-only">{t('srOpen')}</span>}
      className="px-5 pt-0 pb-3 max-h-[50vh] rounded-t-xl"
      showHandle={true}
      title={t('title')}
    >
      <ActivityDrawerContent
        activity={activity}
        onPrev={onPrev}
        onNext={onNext}
        currentIndex={currentIndex}
        totalCount={totalCount}
      />
    </Drawer>
  );
}
